import { SvgIcon, SvgIconProps } from "@sol/uikit/core/icons/SvgIcon";

export const Image = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24">
            <g id="image">
                <g>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M6.375 4C5.06332 4 4 5.06332 4 6.375V17.625C4 18.9367 5.06332 20 6.375 20H17.625C18.9367 20 20 18.9367 20 17.625V6.375C20 5.06332 18.9367 4 17.625 4H6.375ZM2 6.375C2 3.95875 3.95875 2 6.375 2H17.625C20.0412 2 22 3.95875 22 6.375V17.625C22 20.0412 20.0412 22 17.625 22H6.375C3.95875 22 2 20.0412 2 17.625V6.375ZM15.0496 6.93731C15.0496 6.38503 15.4973 5.93731 16.0496 5.93731H16.3713C16.9236 5.93731 17.3713 6.38503 17.3713 6.93731V7.20977C17.3713 7.76206 16.9236 8.20977 16.3713 8.20977H16.0496C15.4973 8.20977 15.0496 7.76206 15.0496 7.20977V6.93731Z"
                        className="fill-current"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M15.2728 12.3041L12.4248 14.9809C11.8585 15.5094 10.9932 15.501 10.4361 14.9954L9.0715 13.8069L7.375 15.2502V16.625H16.625V13.6022L15.2728 12.3041ZM14.2746 10.4977C14.8447 9.96557 15.7313 9.97181 16.2939 10.5119L18.0293 12.1779C18.4099 12.5432 18.625 13.048 18.625 13.5756V17.1563C18.625 17.9674 17.9674 18.625 17.1562 18.625H6.84375C6.03259 18.625 5.375 17.9674 5.375 17.1563V15.2029C5.375 14.8059 5.49692 14.4199 5.72217 14.0962C5.82412 13.9497 5.93706 13.8473 6.00712 13.7879C6.00738 13.7876 6.00765 13.7874 6.00791 13.7872L8.07425 12.0295C8.65298 11.4857 9.56763 11.5003 10.1283 12.0734L10.1296 12.0748L10.1386 12.0841L11.4092 13.1907L14.2746 10.4977Z"
                        className="fill-current"
                    />
                </g>
            </g>
        </SvgIcon>
    );
};
